import React, { useState } from 'react';
import './Login.css'; // We'll create this CSS file for styling
import { Helmet } from 'react-helmet';

function Login({ onLogin, onReset }) {
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const formData = new FormData();
    formData.append('uname', username);
    formData.append('pword', password);

    try {
      const response = await fetch(`${API_ENDPOINT}/index.php`, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        //const text = await response.text(); 
        //console.log("Raw Response:", text);
        const responseData = await response.json();
        
        if (responseData.success) {
          if (responseData['reset']){
            onReset(responseData.username);

          } else {
            // Call the onLogin function passed from the parent component
            onLogin(responseData.token, responseData.expiry, responseData.username, responseData.change);
          }
          
        } else if (responseData.error === 'E_RETRY_AFTER_X_MINUTES') {
          setError(`Too many attempts. Please try again later.`);
        } else {
          throw new Error('Incorrect Username or Password 1');
        }
      } else {
        throw new Error('Incorrect Username or Password 2');
      }
    } catch (e) {
      setError('Incorrect Username or Password 3');
      console.error(e);
    }
  };

  return (
    <div className="container">
      <Helmet>
        <title>Login - Salesperf</title>
      </Helmet>
      <div className="content">
        <form id="form" onSubmit={handleSubmit}>
          <img src='archive/logos/logo-salesperf.png' alt="SalesPerf Logo" width='100%' />
          <br />
          <input 
            type="text" 
            id="uname" 
            name="uname" 
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <br />
          <input 
            type="password" 
            id="pword" 
            name="pword" 
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <br />
          {error && <p className="error">{error}</p>}
          <br />
          <input type="submit" value="Submit" id="submit" />
        </form>
      </div>
    </div>
  );
}

export default Login;

